import Api from '@/services/Api'

export default {
    leaSaldos(){
        return Api().get('leaSaldos')
    },
}
